export const ItemTypes = {
  PRODUCT: 'PRODUCT',
};
